import { Typography } from '@navi/web-ui/lib/primitives';
import GeneratePasswordIcon from '@cp/src/assets/icons/GeneratePasswordIcon';
import UploadNumbersIcon from '@cp/src/assets/icons/UploadNumbersIcon';
import { useNavigate } from 'react-router';
import APP_ROUTES from '@cp/src/layout/Routes';
import { IAmeyoUtility } from '../AmeyoUtility/interfaces';
import styles from './index.module.scss';
import Dropdown from '@cp/src/components/Dropdown';
import { useEffect } from 'react';
import { getAllTenants } from './paramountActions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, store } from '@cp/src/store';
import { setSelectedTenet } from '@cp/pages/Paramount/reducer';
import { toast } from '@navi/web-ui/lib/primitives/Toast';

const transformTenants = (tenants: any) => {
  return tenants.map((tenant: any) => {
    return {
      label: tenant.name,
      value: tenant.referenceId
    };
  });
};

const Paramount = () => {
  const navigate = useNavigate();
  const tenats = useSelector((state: RootState) => state.paramountSlice.tenants);
  const transformedTenats = transformTenants(tenats);
  const currentSelectedTenet = useSelector(
    (state: RootState) => state.paramountSlice.selectedTenet
  );

  useEffect(() => {
    const selectedTenet = localStorage.getItem('selectedTenet');
    if (selectedTenet) {
      const parsedSelectedTenet = JSON.parse(selectedTenet);
      dispatch(setSelectedTenet(parsedSelectedTenet));
    }
  }, []);

  const dispatch = useDispatch();
  const updateSelectedTenet = (selectedTenet: { label: string; key: string }) => {
    const allTenants = store.getState().paramountSlice.tenants;
    const tenantPayload = allTenants.find(tenant => tenant.referenceId === selectedTenet?.value);
    dispatch(setSelectedTenet({ ...selectedTenet, ...tenantPayload }));
    localStorage.setItem('selectedTenet', JSON.stringify({ ...selectedTenet, ...tenantPayload }));
  };
  const handleCardClick = (topath: IAmeyoUtility) => {
    if (currentSelectedTenet) navigate(topath.path);
    else {
      toast('Please select tenant', { type: 'error' });
    }
  };
  const toProducts = APP_ROUTES.PARAMOUNT_PRODUCTS;
  const toTimelines = APP_ROUTES.PARAMOUNT_TIMELINES;
  const toSegments = APP_ROUTES.PARAMOUNT_SEGMENTS;

  useEffect(() => {
    getAllTenants(dispatch);
  }, []);
  return (
    <>
      <div className="flex flex-start mt-[20px] ml-[20px]">
        <Dropdown
          options={transformedTenats}
          defaultSelected={currentSelectedTenet}
          placeholder="Select Tenant"
          onSelectionChange={selectedTenant => {
            updateSelectedTenet(selectedTenant);
          }}
        />
      </div>
      <div className={styles.container}>
        <Typography variant={'h3'} className={styles.headerContainer}>
          Collections Paramount UI
        </Typography>
        <div className={styles.subContainer}>
          <div className={styles.card} onClick={() => handleCardClick(toProducts)}>
            <GeneratePasswordIcon />
            <Typography variant={'h4'} className={styles.cardContent}>
              Products
            </Typography>
          </div>
          <div className={styles.card} onClick={() => handleCardClick(toTimelines)}>
            <UploadNumbersIcon />
            <Typography variant={'h4'} className={styles.cardContent}>
              Timelines
            </Typography>
          </div>
          <div className={styles.card} onClick={() => handleCardClick(toSegments)}>
            <UploadNumbersIcon />
            <Typography variant={'h4'} className={styles.cardContent}>
              Segments
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};

export default Paramount;
